import { useParams } from "react-router-dom";

import { useReadBudgetById } from "../../../hooks/react-query/use-read-budget-by-id";
import { Layout } from "../layout";
import CustomTabs from "./components/custom-tabs";

export const BudgetModules = () => {
    const { budgetId } = useParams();

    const id = budgetId || "";

    const { data: dataBudgetById } = useReadBudgetById({
        budgetId: id,
    });

    return (
        <Layout disableTitle name={dataBudgetById?.name}>
            <CustomTabs />
        </Layout>
    );
};
